// extracted by mini-css-extract-plugin
module.exports = {"filtersButton":"Widget_filtersButton__3iGav","skeleton":"Widget_skeleton__2K9Om"};